(() => {
  const productSelector = ".mindelor-product";
  const accordionSelector = "details[data-mindelor-accordion]";

  const setupAccordion = (details) => {
    if (details.dataset.mindelorAccordionReady === "true") {
      return;
    }

    const summary = details.querySelector("summary");

    if (!summary) {
      return;
    }

    const syncState = () => {
      summary.setAttribute("aria-expanded", details.open ? "true" : "false");
    };

    details.dataset.mindelorAccordionReady = "true";
    details.addEventListener("toggle", syncState);
    syncState();
  };

  const setupProduct = (root = document) => {
    root.querySelectorAll(productSelector).forEach((product) => {
      product.querySelectorAll(accordionSelector).forEach(setupAccordion);
      product.dataset.mindelorProductReady = "true";
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setupProduct());
  } else {
    setupProduct();
  }

  document.addEventListener("shopify:section:load", (event) => {
    setupProduct(event.target);
  });
})();
